<template>
  <path d="M4 0L7.4641 4.5H0.535898L4 0Z" fill="currentColor" />
</template>
